import {
  Briefcase,
  CalendarClock,
  Euro,
  AlertTriangle,
} from '../../../../shared/assets/AppIcons';

export const INITIAL_PROPOSAL_FILTERS = {
  searchTerm: '',
  priorityFilter: 'all',
  assigneeFilter: 'all',
  stageFilter: 'all',
  clientFilter: 'all',
};

export const PROPOSAL_PRIORITY_META = {
  alta: {
    label: 'Alta',
    badgeClass: 'border-[var(--danger-border)] text-[var(--danger-text)] bg-[var(--danger-soft)]',
  },
  media: {
    label: 'Media',
    badgeClass: 'border-[var(--warning-border)] text-[var(--warning-text)] bg-[var(--warning-soft)]',
  },
  bassa: {
    label: 'Bassa',
    badgeClass: 'border-[var(--border-strong)] text-[var(--primary)] bg-[var(--primary-soft)]',
  },
};

export const PROPOSAL_STATS_CONFIG = [
  {
    key: 'total',
    title: 'Totale',
    tone: 'neutral',
    icon: Briefcase,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--success)] to-[var(--chart-accent-2)]',
    iconWrapClass: 'bg-[var(--success-soft)]',
    iconClass: 'text-[var(--success-text)]',
    titleClass: 'text-[var(--success-text)]',
    valueClass: 'text-[var(--success-text)]',
    description: () => 'pipeline attualmente visibile',
  },
  {
    key: 'pipelineVolume',
    title: 'Volume pipeline',
    tone: 'neutral',
    icon: Euro,
    format: 'currency',
  },
  {
    key: 'overdue',
    title: 'Scadute',
    tone: 'attention',
    icon: CalendarClock,
  },
  {
    key: 'highPriority',
    title: 'Alta priorità',
    tone: 'attention',
    icon: AlertTriangle,
  },
];
